import { render, staticRenderFns } from "./SimplePager.vue?vue&type=template&id=99182084&"
import script from "./SimplePager.vue?vue&type=script&lang=js&"
export * from "./SimplePager.vue?vue&type=script&lang=js&"
import style0 from "./SimplePager.vue?vue&type=style&index=0&id=99182084&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports